import { trpc } from '@/shared/api';

interface InvalidateMyQuotes {
  readonly list: () => Promise<void>;
  readonly detail: (quoteRequestId: string) => Promise<void>;
}

/**
 * 내 견적 캐시 무효화 — 목록·상세 invalidation 을 한곳에 모은다(web 최초의 invalidate 헬퍼).
 *
 * 재조회 promise 를 돌려준다 — 뮤테이션이 이것을 기다리면 새 상태가 오기 전에 버튼이 다시 풀리지 않는다.
 */
export const useInvalidateMyQuotes = (): InvalidateMyQuotes => {
  const utils = trpc.useUtils();

  return {
    list: () => utils.quotes.listMine.invalidate(),
    detail: (quoteRequestId) => utils.quotes.getMine.invalidate({ quoteRequestId }),
  };
};
